(function () {
  angular.module("akitabox.ui.dialogs.schedule", [
    "akitabox.ui.dialogs.schedule.create",
    "akitabox.ui.dialogs.schedule.reopen",
    "akitabox.ui.dialogs.schedule.cancel",
    "akitabox.ui.dialogs.schedule.delete",
    "akitabox.ui.dialogs.schedule.editFrequency",
  ]);
})();
